import type {
  BookingCouponsBulkCreateApiData,
  BookingCouponsBulkCreateApiResponses,
  BookingCouponsBulkPreviewApiData,
  BookingCouponsBulkPreviewApiResponses,
  CouponCreateApiData,
  CouponCreateApiResponses,
  CouponDeleteApiData,
  CouponDeleteApiResponses,
  CouponGetApiData,
  CouponGetApiResponses,
  CouponListApiData,
  CouponListApiResponses,
  CouponPatchApiData,
  CouponPatchApiResponses,
  UserGroupCouponListApiData,
  UserGroupCouponListApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const couponUrls = {
  getPaginatedCoupons: dataEndpoint<CouponListApiData, CouponListApiResponses>({
    getUrl: (queryParams) => apiUrl('coupons/', queryParams)
  }),
  getPaginatedUserGroupCoupons: dataEndpoint<UserGroupCouponListApiData, UserGroupCouponListApiResponses>({
    getUrl: ({ userGroupId, ...queryParams }) => apiUrl(`user-groups/${userGroupId}/coupons/`, queryParams)
  }),
  getCoupon: dataEndpoint<CouponGetApiData, CouponGetApiResponses>({
    getUrl: ({ couponId }) => apiUrl(`coupons/${couponId}/`)
  }),
  postCoupon: responseEndpoint<CouponCreateApiData, CouponCreateApiResponses>({
    getUrl: () => apiUrl('coupons/'),
    getBody: (data) => data
  }),
  patchCoupon: responseEndpoint<CouponPatchApiData, CouponPatchApiResponses>({
    getUrl: ({ couponId }) => apiUrl(`coupons/${couponId}/`),
    getBody: (data) => data
  }),
  deleteCoupon: dataEndpoint<CouponDeleteApiData, CouponDeleteApiResponses>({
    getUrl: ({ couponId }) => apiUrl(`coupons/${couponId}/`)
  }),
  postBulkBookingCoupons: responseEndpoint<BookingCouponsBulkCreateApiData, BookingCouponsBulkCreateApiResponses>({
    getUrl: () => apiUrl('bookings/bulk-coupons/'),
    getBody: (data) => data
  }),
  postBulkBookingCouponsPreview: responseEndpoint<
    BookingCouponsBulkPreviewApiData,
    BookingCouponsBulkPreviewApiResponses
  >({
    getUrl: () => apiUrl('bookings/bulk-coupons/preview/'),
    getBody: (data) => data
  })
};
